import type { RegisterRow } from '@myrewards/contracts';
import { formatCount, formatMoney, type WaitingFyi } from '../ui';

function names(row: RegisterRow): string {
  const shown = row.recipients.people.slice(0, 3).map((p) => p.name);
  const more = row.recipients.count - shown.length;
  if (shown.length === 0) return 'people still to be named';
  if (more > 0) return `${shown.join(', ')} and ${formatCount(more)} more`;
  if (shown.length === 1) return shown[0] ?? '';
  return `${shown.slice(0, -1).join(', ')} and ${shown[shown.length - 1] ?? ''}`;
}

function amount(row: RegisterRow): string {
  const cash = formatMoney(row.cashCents);
  return row.options > 0 ? `${cash} cash and ${formatCount(row.options)} options` : cash;
}

/**
 * X1: an Executive Discretionary Bonus waiting on the Executives is decided outside the app (PRD
 * §10.2; Flows: "Executive approvals happen outside the app"), so there's nothing to do here. It
 * still shows on every Executive's dashboard (Flows: "Anything an Executive must approve shows on
 * their dashboard"), as a note under Waiting on you that says who records the decision.
 */
export function edbFyiNotes(rows: readonly RegisterRow[], meId: string): WaitingFyi[] {
  return rows
    .filter(
      (row) =>
        row.type === 'EDB' &&
        row.ended === null &&
        row.stage === 'approval' &&
        row.approval.status === 'waiting' &&
        row.approval.on === 'executives_outside_app',
    )
    .map((row) => {
      const mine = row.enteredBy.id === meId;
      const who = row.enteredBy.name;
      return {
        id: `fyi:${row.award.id}`,
        label: `FYI · ${row.award.displayId}`,
        text: mine
          ? `You requested an Executive Discretionary Bonus for ${names(row)}, ${amount(row)}. The Executives decide outside the app; you or a Stock Admin records what they approve.`
          : `${who} requested an Executive Discretionary Bonus for ${names(row)}, ${amount(row)}. Decide outside the app; ${who} or a Stock Admin records what you approve.`,
      };
    });
}
